import { CheckoutDirectDebitIbanAccountDetails } from '../../models/checkout-payment/checkout-direct-debit-iban-account-details.interface';

export const mockCheckoutDirectDebitIbanAccountDetails: CheckoutDirectDebitIbanAccountDetails =
  {
    accountName: 'accountName',
    iban: 'KW81CBKU00000000000012345601013',
  };
